import { render } from "./BuilderEstimatorHouseSlider.vue?vue&type=template&id=bb2dfda4&scoped=true&ts=true&lang=pug"
import script from "./BuilderEstimatorHouseSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderEstimatorHouseSlider.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderEstimatorHouseSlider.vue?vue&type=style&index=0&id=bb2dfda4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2dfda4"]])

export default __exports__